/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")
@file:OptIn(ExperimentalJsExport::class)
package features.userDetails

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.Result.Idle
import kangaroorewards.appsdk.core.domain.Result.Loading
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kangaroorewards.appsdk.core.utils.CFlow
import kangaroorewards.appsdk.core.utils.asCFlow
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.mapLatest
import kotlinx.serialization.InternalSerializationApi
import kotlin.js.ExperimentalJsExport
import features.userDetails.internal.UserDetailsUseCase
import features.userDetails.internal.UserDetailsUseCase.Params
import features.userDetails.models.UserDetailsModel


typealias UserDetailsState = CFlow<UserDetailsUseCaseResult?>

typealias UserDetailsUseCaseResult = Result<UserDetailsModel>

fun UserDetailsUseCaseResult.serializeUserDetailsApiResult(): SerializedResult<String> {
    return this.toJsonResult<UserDetailsModel>()
}

/**
 * Serializes [UserDetailsState]'s data and returns a new
 * [CFlow] containing data serialized as a JSON [String].
 */
@OptIn(ExperimentalCoroutinesApi::class)
fun UserDetailsState.serializeUserDetailsState(): CFlow<SerializedResult<String>?> {
    return this.mapLatest {
        it?.toJsonResult<UserDetailsModel>()
    }.asCFlow()
}

/**
 * Get user details for this user. [Api] class
 */
class UserDetailsApi : Api() {

    val userDetailsState: UserDetailsState
        get() = _userDetailsState.asCFlow()

    companion object {
        private val _userDetailsState: MutableStateFlow<UserDetailsUseCaseResult> = MutableStateFlow(Idle())
    }

    private val userDetailsUseCase = UserDetailsUseCase()

    /**
     * Get user details for this user.
     */
    suspend fun getUserDetails(
        overrideHeaders: Map<String, String>? = null,

    ): Result<UserDetailsModel> {
        /* set state to Loading as soon as function is called */
        _userDetailsState.value = Loading()
        val result = this.userDetailsUseCase(
            Params(
                overrideHeaders = overrideHeaders,

            )
        
        ) { result ->
            _userDetailsState.value = result
            return@userDetailsUseCase result
        }
        return result
    }

}
